import { useTranslation } from 'react-i18next';
import AngelIcon from '@/components/base/AngelIcon';

export default function CurrentPositionSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2
          className="text-lg md:text-xl text-foreground-800 mb-6 text-center"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t('journey.currentPosition.title')}
          <span className="block text-xs text-foreground-400 font-normal mt-1">
            {t('journey.currentPosition.titleEn')}
          </span>
        </h2>

        {/* Three-step breadcrumb */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4">
          {/* Journey */}
          <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-4 min-w-[180px]">
            <AngelIcon variant="gold" size="md" />
            <div>
              <p className="text-[10px] uppercase tracking-wider text-foreground-400">
                {t('journey.currentPosition.journey')}
              </p>
              <p className="text-sm font-medium text-foreground-800">旅程一</p>
              <p className="text-xs text-foreground-500">身體基礎</p>
            </div>
          </div>

          <div className="text-foreground-300 hidden md:block">→</div>
          <div className="text-foreground-300 md:hidden">↓</div>

          {/* Root */}
          <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-4 min-w-[180px]">
            <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-seedling-line text-primary-500 text-lg" />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wider text-foreground-400">
                {t('journey.currentPosition.root')}
              </p>
              <p className="text-sm font-medium text-foreground-800">自我實現</p>
              <p className="text-xs text-foreground-500">Self Realization</p>
            </div>
          </div>

          <div className="text-foreground-300 hidden md:block">→</div>
          <div className="text-foreground-300 md:hidden">↓</div>

          {/* Node */}
          <div className="flex items-center gap-3 bg-primary-50 border border-primary-200/60 rounded-xl px-5 py-4 min-w-[180px]">
            <div className="w-9 h-9 rounded-full bg-primary-200 flex items-center justify-center">
              <span className="text-primary-700 text-sm font-semibold">3</span>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wider text-primary-400">
                {t('journey.currentPosition.node')}
              </p>
              <p className="text-sm font-medium text-primary-800">承擔</p>
              <p className="text-xs text-primary-500">Accountability</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}